<template>
  <div class="tab">
    <ul class="switches columns">
      <li class="switch-item column" v-for="(item,index) in switches" :key="index" :class="{'active':currentIndex===index}" @click="switchItem(index)">
        <div class="wrapper" :class="{'active':currentIndex===index}">
          <img :src="currentIndex===index?item.colorImg:item.img" v-if="!isMobile"/>
          <div class="title">
            <span class="uptitle">{{item.title}}</span>
            <span class="subtitle">{{item.subtitle}}</span>
            <span class="line" v-if="isMobile" :class="{'active':currentIndex===index}"></span>
          </div>
        </div>
      </li>
    </ul>
    <p v-for="(item, index) in para" :key="index" :class="{'active':currentIndex===index}">{{item}}</p>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {}
  },
  props: {
    switches: {
      type: Array,
      default: () => {}
    },
    currentIndex: {},
    para: {
      type: Array,
      default: () => {}
    }
  },
  created () {},
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  methods: {
    switchItem (idx) {
      this.$emit('switch', idx)
    }
  }
}
</script>

<style scoped lang="sass">
@import '../../style/variable.sass'

div.tab
  height: 76px
  +mobile
    padding: 0
    height: 76px
  .switches
    width: 812px
    height: 76px
    margin: 0 auto
    // margin-bottom: 35px
    +mobile
      width: auto
      height: auto
      display: flex
      margin-bottom: 10px
    li
      cursor: pointer
      position: relative
      height: 76px
      padding: 0
      display: flex
      justify-content: center
      align-items: center
      &:hover
        .title
          color: $primary
      +mobile
        padding: 0.75rem
        padding-bottom: 0rem
        padding-top: 0.4rem
      div.wrapper
        height: 76px
        padding-top: 16px
        +mobile
        &.active
          border-bottom: 1px solid $primary
          +mobile
            border: none
        +mobile
        img
          width: 20px
          margin-right: 10px
          margin-top: 15px
          vertical-align: bottom
          +mobile
            width: 40px
            margin-right: 8px
        .title
          display: inline-block
          +mobile
            display: flex
            height: auto
            align-items: stretch
            flex-direction: column
          .uptitle
            font-size: 20px
            +mobile
              font-size: 16px
              text-align: center
          .subtitle
            color: #999
            font-size: 14px
            +mobile
              font-size: 12px
              margin-bottom: 14px
          .line
            height: 1px
            &.active
              background-color: $primary
        &.active
          .title
            color: $primary
            .subtitle
              color: #999
  p
    display: none
    text-align: center
    width: 67%
    margin: 0 auto
    &.active
      display: block
      // +limit-line-numbers(2)
    +mobile
      font-size: 14px
      display: none
      width: 100%
      margin: 0 auto
</style>
